/* tslint:disable */
import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from "@angular/common/http";
import { BaseService as __BaseService } from "../base-service";
import { ApiConfiguration as __Configuration } from "../api-configuration";
import { StrictHttpResponse as __StrictHttpResponse } from "../strict-http-response";
import { Observable as __Observable } from "rxjs";
import { map as __map, filter as __filter } from "rxjs/operators";

import { CouponLevel } from "../models/coupon-level";
import { CouponsLevels } from "../models/coupons-levels";
@Injectable({
  providedIn: "root",
})
class AdminCouponsLevelsService extends __BaseService {
  static readonly adminCouponsLevelsGetCouponsLevelsPath =
    "/api/admin/subscription/AdminCouponsLevels";
  static readonly adminCouponsLevelsPostCouponsLevelsPath =
    "/api/admin/subscription/AdminCouponsLevels";
  static readonly adminCouponsLevelsGetCouponsLevels2Path =
    "/api/admin/subscription/AdminCouponsLevels/{id}";
  static readonly adminCouponsLevelsPutCouponsLevelsPath =
    "/api/admin/subscription/AdminCouponsLevels/{id}";
  static readonly adminCouponsLevelsDeleteCouponsLevelsPath =
    "/api/admin/subscription/AdminCouponsLevels/{couponCode}/{interactSubType}/{interactSubLevel}/{xmlaSubType}/{xmlaSubLevel}";

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }
  adminCouponsLevelsGetCouponsLevelsResponse(): __Observable<
    __StrictHttpResponse<Array<CouponLevel>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/admin/subscription/AdminCouponsLevels`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<CouponLevel>>;
      })
    );
  }
  adminCouponsLevelsGetCouponsLevels(): __Observable<Array<CouponLevel>> {
    return this.adminCouponsLevelsGetCouponsLevelsResponse().pipe(
      __map((_r) => _r.body as Array<CouponLevel>)
    );
  }

  /**
   * @param couponsLevels undefined
   */
  adminCouponsLevelsPostCouponsLevelsResponse(
    couponsLevels: CouponsLevels
  ): __Observable<__StrictHttpResponse<CouponsLevels>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = couponsLevels;
    let req = new HttpRequest<any>(
      "POST",
      this.rootUrl + `/api/admin/subscription/AdminCouponsLevels`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CouponsLevels>;
      })
    );
  }
  /**
   * @param couponsLevels undefined
   */
  adminCouponsLevelsPostCouponsLevels(
    couponsLevels: CouponsLevels
  ): __Observable<CouponsLevels> {
    return this.adminCouponsLevelsPostCouponsLevelsResponse(couponsLevels).pipe(
      __map((_r) => _r.body as CouponsLevels)
    );
  }

  /**
   * @param params The `AdminCouponsLevelsService.AdminCouponsLevelsGetCouponsLevels2Params` containing the following parameters:
   *
   * - `id`:
   *
   * - `couponCode`:
   */
  adminCouponsLevelsGetCouponsLevels2Response(
    params: AdminCouponsLevelsService.AdminCouponsLevelsGetCouponsLevels2Params
  ): __Observable<__StrictHttpResponse<Array<CouponLevel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    if (params.couponCode != null)
      __params = __params.set("couponCode", params.couponCode.toString());
    let req = new HttpRequest<any>(
      "GET",
      this.rootUrl + `/api/admin/subscription/AdminCouponsLevels/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<CouponLevel>>;
      })
    );
  }
  /**
   * @param params The `AdminCouponsLevelsService.AdminCouponsLevelsGetCouponsLevels2Params` containing the following parameters:
   *
   * - `id`:
   *
   * - `couponCode`:
   */
  adminCouponsLevelsGetCouponsLevels2(
    params: AdminCouponsLevelsService.AdminCouponsLevelsGetCouponsLevels2Params
  ): __Observable<Array<CouponLevel>> {
    return this.adminCouponsLevelsGetCouponsLevels2Response(params).pipe(
      __map((_r) => _r.body as Array<CouponLevel>)
    );
  }

  /**
   * @param params The `AdminCouponsLevelsService.AdminCouponsLevelsPutCouponsLevelsParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `couponsLevels`:
   *
   * - `couponCode`:
   */
  adminCouponsLevelsPutCouponsLevelsResponse(
    params: AdminCouponsLevelsService.AdminCouponsLevelsPutCouponsLevelsParams
  ): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.couponsLevels;
    if (params.couponCode != null)
      __params = __params.set("couponCode", params.couponCode.toString());
    let req = new HttpRequest<any>(
      "PUT",
      this.rootUrl + `/api/admin/subscription/AdminCouponsLevels/${params.id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "blob",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param params The `AdminCouponsLevelsService.AdminCouponsLevelsPutCouponsLevelsParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `couponsLevels`:
   *
   * - `couponCode`:
   */
  adminCouponsLevelsPutCouponsLevels(
    params: AdminCouponsLevelsService.AdminCouponsLevelsPutCouponsLevelsParams
  ): __Observable<Blob> {
    return this.adminCouponsLevelsPutCouponsLevelsResponse(params).pipe(
      __map((_r) => _r.body as Blob)
    );
  }

  /**
   * @param params The `AdminCouponsLevelsService.AdminCouponsLevelsDeleteCouponsLevelsParams` containing the following parameters:
   *
   * - `xmlaSubType`:
   *
   * - `xmlaSubLevel`:
   *
   * - `interactSubType`:
   *
   * - `interactSubLevel`:
   *
   * - `couponCode`:
   */
  adminCouponsLevelsDeleteCouponsLevelsResponse(
    params: AdminCouponsLevelsService.AdminCouponsLevelsDeleteCouponsLevelsParams
  ): __Observable<__StrictHttpResponse<CouponsLevels>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      "DELETE",
      this.rootUrl +
        `/api/admin/subscription/AdminCouponsLevels/${params.couponCode}/${params.interactSubType}/${params.interactSubLevel}/${params.xmlaSubType}/${params.xmlaSubLevel}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: "json",
      }
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<CouponsLevels>;
      })
    );
  }
  /**
   * @param params The `AdminCouponsLevelsService.AdminCouponsLevelsDeleteCouponsLevelsParams` containing the following parameters:
   *
   * - `xmlaSubType`:
   *
   * - `xmlaSubLevel`:
   *
   * - `interactSubType`:
   *
   * - `interactSubLevel`:
   *
   * - `couponCode`:
   */
  adminCouponsLevelsDeleteCouponsLevels(
    params: AdminCouponsLevelsService.AdminCouponsLevelsDeleteCouponsLevelsParams
  ): __Observable<CouponsLevels> {
    return this.adminCouponsLevelsDeleteCouponsLevelsResponse(params).pipe(
      __map((_r) => _r.body as CouponsLevels)
    );
  }
}

module AdminCouponsLevelsService {
  /**
   * Parameters for AdminCouponsLevelsGetCouponsLevels2
   */
  export interface AdminCouponsLevelsGetCouponsLevels2Params {
    id: string;
    couponCode?: null | string;
  }

  /**
   * Parameters for AdminCouponsLevelsPutCouponsLevels
   */
  export interface AdminCouponsLevelsPutCouponsLevelsParams {
    id: string;
    couponsLevels: CouponsLevels;
    couponCode?: null | string;
  }

  /**
   * Parameters for AdminCouponsLevelsDeleteCouponsLevels
   */
  export interface AdminCouponsLevelsDeleteCouponsLevelsParams {
    xmlaSubType: number;
    xmlaSubLevel: number;
    interactSubType: number;
    interactSubLevel: number;
    couponCode: null | string;
  }
}

export { AdminCouponsLevelsService };
